// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25OIr","rootNoMargin":"styles_rootNoMargin__1UAvB"};